import { render, staticRenderFns } from "./RequestDetails.vue?vue&type=template&id=802a3920&"
import script from "./RequestDetails.vue?vue&type=script&lang=ts&"
export * from "./RequestDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports